import angular from 'angular';
import cmsAuth from '../../Auth/CMSAuthService';
import config from '../../ConfigModule/ConfigModule';
import cmsLanguageChanger from '../../Language/LanguageChanger';
import avatar from '../../AvatarFilter/AvatarFilter';

/** @ngInject */
let baPageTopDirectiveDecorator = function baPageTopDirectiveDecorator($delegate, CMSAuthService, CONFIG, $window, ACLService) {

    $delegate.forEach(function (directiveDefinition) {
        directiveDefinition.template = require('./pageTop.html');
        directiveDefinition.controllerAs = 'vm';
        directiveDefinition.controller = function () {

            let vm = {};
            vm.logout = function () {
                CMSAuthService.logout(function () {
                    window.location.href = "/login.html";
                });
            };
            vm.user = CMSAuthService.getUser();

            vm.matchRoles = ACLService.matchRoles('ROLE_USER');

            vm.reloadRoute = function() {
                $window.location.reload();
            };

            return vm;

        }
    });

    return $delegate;
};

let baPageTopDirectiveConfig = function ($provide) {
    /** @ngInject */
    $provide.decorator('pageTopDirective', baPageTopDirectiveDecorator);
};

/**
 * PageTop module based on pageTop from blur admin
 *
 * @namespace cms.blur-admin.pageTopDecorator
 *
 * @see {@link /node_modules/blur_admin/src/app/theme/components/pageTop}
 */
export default angular.module('cms.blur-admin.baPageTopDirectiveDecorator', [angular.module('BlurAdmin.theme').name, cmsAuth, config, cmsLanguageChanger, avatar])
    .config(baPageTopDirectiveConfig).name;


// WEBPACK FOOTER //
// ./src/cmsCore/BlurAdmin/baPageTopDecorator/pageTopDirectiveDecorator.js